import { render, staticRenderFns } from "./r-patch-builder-dialog-v1.vue?vue&type=template&id=7009ff7c&scoped=true"
import script from "./r-patch-builder-dialog-v1.vue?vue&type=script&lang=js"
export * from "./r-patch-builder-dialog-v1.vue?vue&type=script&lang=js"
import style0 from "./r-patch-builder-dialog-v1.vue?vue&type=style&index=0&id=7009ff7c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7009ff7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7009ff7c')) {
      api.createRecord('7009ff7c', component.options)
    } else {
      api.reload('7009ff7c', component.options)
    }
    module.hot.accept("./r-patch-builder-dialog-v1.vue?vue&type=template&id=7009ff7c&scoped=true", function () {
      api.rerender('7009ff7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/patch/r-patch-builder-dialog-v1.vue"
export default component.exports